<div class="search-results-item d-flex align-items-center">
  <div class="name">
    <a [article]="discussion">{{ discussion.name }}</a>
  </div>
</div>
